import React from "react";
import Mydata from "@/app/data/blog/chicago-Ohare.json";
function tableData() {
  const Data = Mydata[4];
  return (
    <div className="mx-auto max-w-5xl px-4 text-[#2B3252] text-lg">
      {Data.ParkingOptions.map((option, index) => (
        <div key={index} className="mb-8">
          {/* Main Title */}
          <h2 id={option.id} className="blogtitle">{option.title}</h2>
          <p className="blogcontent">{option.description}</p>
          <p className="blogcontent">{option.des2}</p>

          {option.sections.map((section, secIndex) => (
            <div key={secIndex} className="">
              <h3 id={section.id} className="blogSubtitle">{section.heading}</h3>

              {section.image && (
                <img
                  src={section.image}
                  alt={section.heading}
                  className="mb-4 rounded-[20px]"
                />
              )}
              <p className="blogcontent">{section.content}</p>
              <p className="blogcontent">{section.content2}</p>

              {section.subsections &&
                section.subsections.map((subsection, subIndex) => (
                  <div key={subIndex} className="">
                    <h4 className="blogh4">{subsection.title}</h4>
                    <p className="blogcontent">{subsection.description}</p>
                    <ul className="list-disc pl-4  ">
                      {subsection.rates.map((rate, rateIndex) => (
                        <li
                          className="blogcontent"
                          key={rateIndex}
                          dangerouslySetInnerHTML={{ __html: rate }}
                        />
                      ))}
                    </ul>
                  </div>
                ))}

              {section.rates_table && (
                <table className="w-full border border-gray-300 mt-4 mb-4">
                  <thead>
                    <tr>
                      {section.rates_table[0].map((header, headerIndex) => (
                        <th
                          key={headerIndex}
                          className="border border-gray-300 px-2 py-1 text-left cardbg"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {section.rates_table.slice(1).map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                          <td
                            key={cellIndex}
                            className="border border-gray-300 px-2 py-1"
                          >
                            {cell}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {section.rates && (
                <ul className="list-disc pl-6 mb-4">
                  {section.rates.map((rate, rateIndex) => (
                    <li key={rateIndex}>{rate}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default tableData;
